import DriverAccountingApi from "../../services/api/DriverAccounting";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import ErrorMsgs from "../../constants/Errors.json";
import { getPath, getQueryParams } from "../../utils";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in driver accounting actions:", err);
}

export const setSettlementProcesses = (payload) => {
  return {
    type: ActionTypes.SET_DRIVER_ACCOUNTING_SETTLEMENT_PROCESSES,
    payload,
  };
};

export const setActiveFiltersSettlementProcesses = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_DRIVER_ACCOUNTING_SETTLEMENT_PROCESSES_FILTERS,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_DRIVER_ACCOUNTING_SETTLEMENT_PROCESSES,
    payload,
  };
};

export const setCurrentPageSettlementProcess = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_DRIVER_ACCOUNTING_SETTLEMENT_PROCESS,
    payload,
  };
};

export const getSettlementProcesses =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let finalPayload = {
        ...pageRequest,
        ...filters,
      };

      const queryString = getQueryParams(finalPayload);
      dispatch(setLoader(true));
      let response = await DriverAccountingApi.getSettlementProcesses(
        queryString
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setSettlementProcesses(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(
            setCurrentPageSettlementProcess(getPath(pageRequest, "page", 1))
          );
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFiltersSettlementProcesses(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeSettlementProcessesFilters" }));
        }
        return response;
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const createSettlementProcess = (data) => async (dispatch) => {
  try {
    let finalPayload = { driver_settlement_process: data };
    dispatch(setLoader(true));
    let response = await DriverAccountingApi.createSettlementProcess(
      finalPayload
    );
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.CREATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const triggerNextEvent = (id) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await DriverAccountingApi.triggerNextEvent(id);
    dispatch(setLoader(false));
    if (response) {
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
